import api from '../../api/restaurant/restaurantMenuCategoryApi';
import {
  CustomResponse,
  RestaurantMenuCategoryDTO,
  RestaurantMenuCategoryFilters,
  RestaurantMenuCategoryForm,
  RestaurantMenuCategoryPage,
} from '../../types/restaurant/RestaurantMenuTypes';
import { restaurantPageQuery } from './restaurantPageQuery';
const payload = (form: RestaurantMenuCategoryForm) => ({
  name: form.name.trim(),
  description: form.description.trim() || null,
  icon: form.icon.trim() || null,
  color: form.color.trim() || null,
  displayOrder: Number(form.displayOrder),
  // El código lo genera el backend a partir del nombre y lo conserva al
  // editar; el formulario ya no lo envía.
  ...(form.id ? { active: form.active } : {}),
});
const RestaurantMenuCategoryService = {
  listFiltered: async (
    branchId: number,
    filters: RestaurantMenuCategoryFilters
  ) => {
    const query = restaurantPageQuery(filters.page, filters.size);
    return (
      await api.addCustom(`/branches/${branchId}/filtered?${query}`, {
        search: filters.search?.trim() || null,
        active: filters.active,
      })
    ).data as RestaurantMenuCategoryPage;
  },
  list: async (branchId: number, activeOnly = false) =>
    (await api.fetchCustom(`/branches/${branchId}?activeOnly=${activeOnly}`))
      .data as CustomResponse<RestaurantMenuCategoryDTO[]>,
  get: async (id: number) =>
    (await api.fetchById(id)).data as CustomResponse<RestaurantMenuCategoryDTO>,
  create: async (branchId: number, form: RestaurantMenuCategoryForm) =>
    (await api.addCustom(`/branches/${branchId}`, payload(form)))
      .data as CustomResponse<RestaurantMenuCategoryDTO>,
  update: async (id: number, form: RestaurantMenuCategoryForm) =>
    (await api.modify(id, payload(form)))
      .data as CustomResponse<RestaurantMenuCategoryDTO>,
  updateActive: async (id: number, active: boolean) =>
    (await api.patchCustom(`${id}/active`, { active }))
      .data as CustomResponse<RestaurantMenuCategoryDTO>,
};
export default RestaurantMenuCategoryService;
